@for (listValue of filterList | byWord:findDropdown:fieldToFind; track $index) {
  <div [ngClass]="{'common-dropdown-list__cascade-item-with-cursor': field.isTree && listValue.children?.length,
    'common-dropdown-list__user-item': !(field.isTree && listValue.children?.length)}"
    [ngStyle]="{'padding-left': (16*level)+(listValue.children?.length?8:0)+'px'}"
    (click)="launchAction(listValue)"
    [attr.disabled]="listValue.disabled || field.noEditable?true:null">
    <div [ngClass]="{'common-dropdown-list__container-icon-arrow': field.isTree && !field.uniqueLastSelect && !listValue.children?.length}">
      @if (listValue.children?.length){
        <button class="common-button__icon-sm-noborder">
          <i class="common-icon__md"
            [ngClass]="listValue.show?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
        </button>
      }
    </div>
    <div class="common-dropdown-list__item-container">
      @if(!field.uniqueLastSelect || !listValue.children?.length) {
        <div class="common-button__block-button-md-checkbox">
          <button class="common-button__icon-md-checkbox"
            [ngClass]="{'common-button__icon-md-checkbox--selected': listValue.selected}"
            (click)="selectOption(listValue, $event)"
            [disabled]="listValue.disabled || field.noEditable">
            <i class="common-icon__md"
              [ngClass]="{'lf-icon-check-full': field.multiple && listValue.selected,
                'lf-icon-box-inactive': field.multiple && !listValue.selected,
                'lf-icon-radio-button-active': !field.multiple && listValue.selected,
                'lf-icon-step-first': !field.multiple && !listValue.selected}"></i>
          </button>
        </div>
      }
      <div class="common-dropdown-list__user-item-wrapper">
        <span-tooltip class="common-dropdown__list-text-title"
          [text]="listValue.text"
          [isDeleted]="listValue.isDeleted"></span-tooltip>
        @if(listValue.isUserValue){
          <i class="lf-icon-configuration common-icon__md common-icon__neutral"></i>
        }
      </div>
    </div>
  </div>
  @if (listValue.children?.length && listValue.show) {
    <tree-list-children class="common-dropdown-list__tree-container"
      [field]="field"
      [findDropdown]="findDropdown"
      [fieldToFind]="fieldToFind"
      [filterList]="listValue.children"
      [level]="nextLevel"
      (treeChildrenEmit)="treeChildrenOn($event)">
    </tree-list-children>
  }
}
